import React from "react";

export interface LanguageMeta {
  code: string;
  name: string;
  flag: string;
  default: boolean;
}

export interface LanguageContextSchema {
  selectedLanguage: string;
  availableLanguages: LanguageMeta[];
  setLanguage: (lang: string) => void;
}

export const LanguageContext = React.createContext<LanguageContextSchema>(
  {} as LanguageContextSchema
);
